import { render, staticRenderFns } from "./AnkantuInput.vue?vue&type=template&id=11c279ba&scoped=true"
import script from "./AnkantuInput.vue?vue&type=script&lang=js"
export * from "./AnkantuInput.vue?vue&type=script&lang=js"
import style0 from "./AnkantuInput.vue?vue&type=style&index=0&id=11c279ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c279ba",
  null
  
)

export default component.exports